import { useState } from "react";
import BaseModal from "../Base-modal";

const ConfirmModal = ({ onConfirm, open, setOpen }) => {
//   const [open, setOpen] = useState(false);
  return (
    <BaseModal open={open} closeModal={() => setOpen(!open)}>
      <div>
        <div>
          <h2 style={{ fontFamily: "sans-serif" }}>
            Are you sure to confirm this transaction?
          </h2>
        </div>

        <div className="btns-container">
          <button className="cancel" onClick={() => setOpen(!open)}>
            Back
          </button>
          <button className="apply" onClick={onConfirm}>
            Approve
          </button>
        </div>
      </div>
    </BaseModal>
  );
};

export default ConfirmModal;
